module.exports = __webpack_public_path__ + "static/media/meme_10.ec788ed5.jpg";